import { Box, Center, Container, Stack, Text, Title } from '@mantine/core';
import { IconTool } from '@tabler/icons-react';

export function MaintenanceScreen() {
  return (
    <Box bg="gray.10" h="100vh">
      <Container size="sm">
        <Center h="100vh">
          <Stack align="center">
            <Box
              bg="brand.6"
              style={{
                width: 120,
                height: 120,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <IconTool size={64} color="white" strokeWidth={1.5} />
            </Box>

            <Stack align="center">
              <Title
                order={1}
                c="gray.0"
                style={{
                  fontSize: '2.5rem',
                  fontWeight: 700,
                  textAlign: 'center',
                }}
              >
                Under Maintenance
              </Title>

              <Text size="lg" c="gray.1" style={{ textAlign: 'center', maxWidth: '500px' }}>
                {
                  "We're currently performing scheduled maintenance to improve your experience. We'll be back shortly."
                }
              </Text>

              <Text size="sm" c="gray.3" style={{ textAlign: 'center' }}>
                Thank you for your patience.
              </Text>
            </Stack>
          </Stack>
        </Center>
      </Container>
    </Box>
  );
}
